/**
 * Join Page observability service for tracking form submission events.
 * 
 * Tracks only join form submission failures.
 */

import { trackEvent } from '../utils/event-tracker';
import {
  JOIN_FORM_SUBMIT_FAILURE,
} from '../constants/join-page-events';

/**
 * Parameters for tracking a failed join form submission.
 */
export interface JoinFormSubmitFailureParams {
  /** The error message or details */
  error: string;
  
  /** Session ID for tracking this form instance */
  sessionId: string;
}

export const JoinPageObservabilityService = {
  /**
   * Track when a join form submission fails.
   */
  trackFormSubmitFailure(params: JoinFormSubmitFailureParams): void {
    const { error, sessionId } = params;
    
    trackEvent(JOIN_FORM_SUBMIT_FAILURE, {
      error,
      sessionId,
    });
  },
};
